import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0, 6),
  },
  Contentcontainer: {
    paddingTop: theme.spacing(3),
    padding: theme.spacing(0, 6),
    paddingBottom: theme.spacing(4),
  },
  listItemPrices: {
    borderRight: "1px dashed transparent !important",
    borderLeft: "1px dashed transparent !important",
  },
  hoverItemsClass: {
    borderRight: `1px dashed ${theme.palette.secondary.tint40} !important`,
    borderLeft: `1px dashed ${theme.palette.secondary.tint40} !important`,
    "&:first-child": {
      borderTopLeftRadius: [theme.spacing(2), "!important"],
      borderTopRightRadius: [theme.spacing(2), "!important"],
    },
    "&:last-child": {
      borderBottomLeftRadius: [theme.spacing(2), "!important"],
      borderBottomRightRadius: [theme.spacing(2), "!important"],
    },
  },
  block: {
    borderRight: `1px solid ${theme.palette.background.main}`,
    height: "90%",
  },
}));
